module.exports = __webpack_public_path__ + "static/media/htw.f9cdcf7c.png";